import { render, staticRenderFns } from "./beyannameformat.vue?vue&type=template&id=690481a6&"
import script from "./beyannameformat.vue?vue&type=script&lang=js&"
export * from "./beyannameformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports